export default function SearchResultsHit({ hit }) {
  return (
    <div className="border-b border-grey-light py-md">
      {hit?.post_title && hit?.permalink ? (
        <h4 className="h4 text-[24px] font-bold font-primary">
          <a
            href={hit.permalink}
            className="text-blue-oxford hover:text-gold duration-200">
            {hit?.post_title}
          </a>
        </h4>
      ) : null}

      {hit?.post_type_label ? (
        <span className="block text-xs text-[#7b7b7b] mb-xs">
          {hit.post_type_label}
        </span>
      ) : null}

      {hit?.post_excerpt ? (
        <span
          className="sm:text-[18px]"
          dangerouslySetInnerHTML={{ __html: hit.post_excerpt }}
        />
      ) : null}

      {!hit?.post_excerpt && hit?.description ? (
        <span
          className="sm:text-[18px]"
          dangerouslySetInnerHTML={{ __html: hit.description }}
        />
      ) : null}
    </div>
  )
}
